import React, { useState, useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
interface MagnetProps {
  children: ReactNode;
  strength?: number;
  className?: string;
  disabled?: boolean;
}
export function Magnet({
  children,
  strength = 0.35,
  className = '',
  disabled = false
}: MagnetProps) {
  const ref = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const springX = useSpring(x, {
    stiffness: 200,
    damping: 20,
    mass: 0.5
  });
  const springY = useSpring(y, {
    stiffness: 200,
    damping: 20,
    mass: 0.5
  });
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disabled || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    x.set((e.clientX - cx) * strength);
    y.set((e.clientY - cy) * strength);
  };
  const handleLeave = () => {
    x.set(0);
    y.set(0);
  };
  return <motion.div ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave} style={{
    x: springX,
    y: springY
  }} className={`inline-block ${className}`} data-id="element-132">
      {children}
    </motion.div>;
}